import { render, staticRenderFns } from "./AuthoritiesView.vue?vue&type=template&id=6d4e64e6"
import script from "./AuthoritiesView.vue?vue&type=script&lang=js"
export * from "./AuthoritiesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports